import Uint8Array from "./_Uint8Array.js";
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  return new Uint8Array(result).set(new Uint8Array(arrayBuffer)), result;
}
export {
  cloneArrayBuffer as default
};
//# sourceMappingURL=_cloneArrayBuffer.js.map
